import React from 'react';
import { DropdownButton } from './DropdownButton';
import './StatusSelect.scss';
export function StatusSelect(props) {
    const { disabled, type, value } = Object.assign({}, props);
    const statusOptions = getStatusOptions(type);
    return (React.createElement("div", { className: "status-select-container" },
        React.createElement(DropdownButton, { style: "normal", size: "small", options: statusOptions, value: value, onSelect: props.onChange, disabled: disabled })));
}
export function getStatusOptions(type) {
    let statusOptions = [];
    if (type === 'DEAL') {
        statusOptions = [
            {
                value: 'ACTIVE',
                label: t('Active'),
                color: 'yellow'
            },
            {
                value: 'WON',
                label: t('Won'),
                color: 'green'
            },
            {
                value: 'LOST',
                label: t('Rejected'),
                color: 'red'
            },
            {
                value: 'CANCELLED',
                label: t('Cancelled'),
                color: 'orange'
            },
            {
                value: 'INACTIVE',
                label: t('Inactive'),
                color: 'light-gray'
            }
        ];
    }
    else if (type === 'AGREEMENT') {
        statusOptions = [
            {
                value: 'ACTIVE',
                label: t('Active'),
                color: 'yellow'
            },
            {
                value: 'SIGNED',
                label: t('Signed'),
                color: 'green'
            },
            {
                value: 'CANCELLED',
                label: t('Cancelled'),
                color: 'orange'
            },
            {
                value: 'INACTIVE',
                label: t('Inactive'),
                color: 'light-gray'
            }
        ];
    }
    else if (type === 'DEAL_PAYMENT') {
        statusOptions = [
            {
                value: 'ACTIVE',
                label: t('Scheduled'),
                color: 'yellow'
            },
            {
                value: 'COMPLETED',
                label: t('Paid'),
                color: 'green'
            },
            {
                value: 'INACTIVE',
                label: t('Inactive'),
                color: 'light-gray'
            }
        ];
    }
    else if (type === 'ORDER' || type === 'TASK_LIST') {
        statusOptions = [
            {
                value: 'ACTIVE',
                label: t('Active'),
                color: 'yellow'
            },
            {
                value: 'COMPLETED',
                label: t('Completed'),
                color: 'green'
            },
            {
                value: 'CANCELLED',
                label: t('Cancelled'),
                color: 'red'
            },
            {
                value: 'INACTIVE',
                label: t('Inactive'),
                color: 'light-gray'
            }
        ];
    }
    else if (type === 'CLIENT_CONTACT') {
        statusOptions = [
            {
                value: 'LEAD',
                label: t('Lead'),
                color: 'yellow'
            },
            {
                value: 'CLIENT',
                label: t('Client'),
                color: 'green'
            }
        ];
    }
    return statusOptions;
}
export function getStatusOption(type, value) {
    const normalized = value === null || value === void 0 ? void 0 : value.toUpperCase();
    const match = getStatusOptions(type).find((option) => option.value === normalized);
    if (match || (type !== 'DEAL' && type !== 'AGREEMENT')) {
        return match;
    }
    /*
     * A stored status can belong to the other module (a signed agreement
     * indexed with the quotes, for one). The menus stay module-specific;
     * only the label of an existing value falls back.
     */
    const sibling = type === 'DEAL' ? 'AGREEMENT' : 'DEAL';
    return getStatusOptions(sibling).find((option) => option.value === normalized);
}
export function getClientContactStatusLabel(status) {
    var _a, _b, _c;
    return (_c = (_b = (_a = getStatusOption('CLIENT_CONTACT', status)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : status) !== null && _c !== void 0 ? _c : '';
}
